import React, { useEffect, useState } from "react";

function TimeoutErrorHandler() {
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    window.location.href = "/login"; // Redirect directly
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <div className="d-flex justify-content-center" style={{ alignItems: "center", height:"40vh" }}>
            <div>
                <h1><span style={{ fontSize:'2.5 rem' }} role="img" aria-label="warning">⚠️</span> 440 - Session Timeout</h1>
                <p className="text-center">Session has expired. Redirecting to login in <strong>{countdown} seconds</strong>.</p>
            </div>
        </div>
    );
}

export default TimeoutErrorHandler;